import type { SearchTableQuery } from "owa-mail-list-search";
import { getTableItemRelation, MailRowDataPropertyGetter, type MailListRowDataType, type TableView } from "owa-mail-list-store";
import TableOperations from "owa-mail-list-table-operations";
import { getTableViewFromTableQuery } from "owa-mail-triage-table-utils";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { mutatorAction } from "satcheljs";

const setPreservedRecentRowsMutator = mutatorAction("setPreservedQueryOnTypeRecentRows", (tableView: TableView, recentRowKeys: string[], recentReferenceKeys: string[], highlightTerms: string[], highlightAccuracy: TableView["highlightAccuracy"]): void => {
    tableView.recentRowKeys = recentRowKeys;
    tableView.recentReferenceKeys = recentReferenceKeys;
    tableView.hasPreservedQueryOnTypeRecentRows = true;
    tableView.highlightTerms = highlightTerms;
    tableView.highlightAccuracy = highlightAccuracy;
});

export default function preserveQueryOnTypeRecentRows(sourceTableView: TableView | undefined, submittedTableQuery: SearchTableQuery): void {
    const sourceTableQuery = sourceTableView?.tableQuery as SearchTableQuery | undefined;
    const hasQueryOnTypeRecentRows = sourceTableQuery?.scenarioType === "queryOnType" ||
        (sourceTableQuery?.scenarioType === "mail" &&
            sourceTableView?.hasPreservedQueryOnTypeRecentRows === true);
    if (!sourceTableView ||
        !hasQueryOnTypeRecentRows ||
        submittedTableQuery.scenarioType !== "mail" ||
        sourceTableQuery.queryString !== submittedTableQuery.queryString ||
        sourceTableQuery.listViewType !== 1 ||
        submittedTableQuery.listViewType !== 1 ||
        !sourceTableView.recentRowKeys?.length) {
        return;
    }
    
    const submittedTableView = getTableViewFromTableQuery(submittedTableQuery);
    if (submittedTableView.rowKeys.length > 0) {
        return;
    }
    
    const preservedRowKeys: string[] = [];
    const preservedReferenceKeys: string[] = [];
    
    for (const [index, rowKey] of sourceTableView.recentRowKeys.entries()) {
        const item = MailRowDataPropertyGetter.getItem(rowKey, sourceTableView);
        const relation = getTableItemRelation(rowKey, sourceTableView.id);
        if (!item || !relation) {
            continue;
        }
        
        const referenceKey = sourceTableView.recentReferenceKeys?.[index];
        const row: MailListRowDataType = {
            ...item,
            __typename: "ItemRow",
            id: relation.clientId.Id,
            ItemId: relation.clientId,
            InstanceKey: rowKey,
            SortOrderSource: relation.executeSearchSortOrder,
            ReferenceKey: referenceKey,
        } as MailListRowDataType;
        
        if (TableOperations.addRowMutator(submittedTableView.rowKeys.length, row, submittedTableView, "", false, "SearchMessageSuggestion")) {
            preservedRowKeys.push(rowKey);
            if (referenceKey) {
                preservedReferenceKeys.push(referenceKey);
            }
        }
    }
    
    if (preservedRowKeys.length > 0) {
        setPreservedRecentRowsMutator(submittedTableView, preservedRowKeys, preservedReferenceKeys, sourceTableView.highlightTerms ?? [], sourceTableView.highlightAccuracy);
    }
}
